import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import LocationModal from './components/LocationModal';
import LocationChangeModal from './components/LocationChangeModal';
import ScrollToTop from './components/ScrollToTop';
import Menu from './pages/Menu';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import './App.css';

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <LocationModal />
      <LocationChangeModal />
      <Navigation />
      <Routes>
        <Route path="/" element={<Menu />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
      </Routes>
    </div>
  );
}

export default App;
